export default __webpack_public_path__ + "static/media/home1.e3fc06d8.jpg";